import { type ReactNode } from 'react';
import styled from 'types/theme.types';
import { BREADCRUMB_BAR_HEIGHT } from 'constants/themes.constants';
import { BaseItemContainer } from 'components/layout/navbar/navbar-panel.utils';
import { useNavbarCollapse } from 'components/layout/navbar/navbar-collapse-context';

interface NavbarHeaderProps {
  menuTitle: string;
  menuIcon: ReactNode;
}

const NavbarHeader = ({ menuTitle, menuIcon }: NavbarHeaderProps) => {
  const { isCollapsed } = useNavbarCollapse();
  return (
    <NavbarHeaderContainer>
      <BaseItemContainer>
        <IconContainer>{menuIcon}</IconContainer>
        {!isCollapsed && <NavbarTitle>{menuTitle}</NavbarTitle>}
      </BaseItemContainer>
    </NavbarHeaderContainer>
  );
};

const NavbarHeaderContainer = styled.div`
  height: ${BREADCRUMB_BAR_HEIGHT};
`;

const IconContainer = styled.div`
  * {
    color: ${({ theme }) => theme.lightGray};
  }
`;

const NavbarTitle = styled.div`
  font-weight: bold;
  font-size: 14px;
  color: ${({ theme }) => theme.lightGray};
`;

export default NavbarHeader;
